import type { TelemetryReading } from '@micplot/shared';

/**
 * Live readings for one channel.
 *
 * Battery first: a pack dying mid-scene is the failure this whole display
 * exists to prevent. Levels sit behind it because they are glanceable rather
 * than actionable.
 */
export default function RfMeter({ t, compact }: { t: TelemetryReading; compact?: boolean }) {
  const bars = t.batteryBars;
  const low = bars !== undefined && bars <= 1;
  const warn = bars !== undefined && bars === 2;

  return (
    <span className={`rf${compact ? ' compact' : ''}`}>
      {bars !== undefined && (
        <span className={`rf-batt${low ? ' low' : warn ? ' warn' : ''}`}
              title={t.batteryMinutes !== undefined
                ? `${t.batteryMinutes} min remaining`
                : 'battery'}>
          <span className="rf-bars">
            {[1, 2, 3, 4, 5].map(i => (
              <i key={i} className={i <= bars ? 'on' : ''} />
            ))}
          </span>
          {t.batteryMinutes !== undefined && !compact && (
            <span className="rf-mins">{formatMinutes(t.batteryMinutes)}</span>
          )}
        </span>
      )}

      {t.rfLevel !== undefined && (
        <span className="rf-num" title="RF level">{t.rfLevel}<small>dBm</small></span>
      )}
      {t.audioLevel !== undefined && (
        <span className="rf-level" title={`audio ${t.audioLevel} dBFS`}>
          <i style={{ width: `${audioPercent(t.audioLevel)}%` }} />
        </span>
      )}
      {t.muted && <span className="chip chip-danger">MUTE</span>}
    </span>
  );
}

const formatMinutes = (m: number) =>
  m >= 60 ? `${Math.floor(m / 60)}h${String(m % 60).padStart(2, '0')}` : `${m}m`;

/** -60 dBFS and below reads as silence; 0 is full scale. */
const audioPercent = (db: number) =>
  Math.max(0, Math.min(100, Math.round(((db + 60) / 60) * 100)));
